export const email = "radek@bubienko.pl";